export default {
  inlineDatePicker: {
    selectDay: 'Выберите день',
    selectMonth: 'Выберите месяц',
    selectYear: 'Выберите год'
  },
  uploader: {
    moveOrLoadPhotoStart: '',
    moveOrLoadPhotoEnd: 'Загрузить фотографию',
    sizeError: 'Файл больше 10 Мб',
    remove: 'Удалить'
  }
}
